import React from "react";
import clsx from "clsx";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

/**
 * Standard page-level card shell: white background, rounded corners, hairline
 * border, subtle shadow. This is the one place that treatment is defined —
 * don't hand-copy the "bg-white rounded-xl border border-slate-100 shadow-sm"
 * className string into a new component, import <Card> instead.
 */
const Card = ({ children, className = "", onClick }: CardProps) => {
  return (
    <div
      onClick={onClick}
      className={clsx(
        "bg-white rounded-xl border border-slate-100 shadow-sm",
        onClick && "cursor-pointer hover:shadow-md hover:border-slate-200 transition-shadow duration-150",
        className,
      )}
    >
      {children}
    </div>
  );
};

export default Card;
